import React from "react"

import { Typography } from "antd"

import styles from "../CreditRequestInstructions.module.less"

const { Text } = Typography

export const NumberedListItem = ({ number, text }) => {
  return (
    <div className={styles.numberedListItem}>
      <Text className={styles.number}>{number}.</Text>
      <Text className={styles.text}>{text}</Text>
    </div>
  )
}
